<script setup>
import { computed } from 'vue';
import { RadioGroupProvider } from './useRadioGroup';

const props = defineProps({
  value: {
    type: [String, Number],
    default: '',
  },
});

const emit = defineEmits(['input', 'change']);

function setValue(value) {
  console.log('setValue', value);
  emit('input', value);
  emit('change', value);
}

RadioGroupProvider({
  rootProps: computed(() => {
    return props;
  }),
  setValue,
});
</script>

<template>
  <fieldset data-component="RadioGroup" class="flex flex-col gap-2">
    <slot />
  </fieldset>
</template>
